/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */

import store from '@/store';
import productService from '@/services/product';
import Vue from 'vue';

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
  },
  data() {
    return {
      form: {
        name: '',
        refCode: '',
        productType: '',
        price: undefined,
        retailPrice: undefined,
        remark: '',
        brand: '',
        images: [],
        size: '',
        color: '',
      },
      field: {},
      count: 0,
      fieldDisplay: {},
      states: [],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    async onSubmit(form, stay) {
      try {
        form.brandId = form.brand;
        form.productTypeId = form.productType;

        const response = await productService.create(form);

        if (response.data.error) {
          this.$message.error(response.data.error.message);
        } else {
          if (!stay) {
            return this.navigate({ name: 'product.view' });
          }

          this.form = {
            name: '',
            refCode: '',
            type: '',
            price: undefined,
            retailPrice: undefined,
            remark: '',
            images: [],
            size: '',
            color: '',
          };
        }
      } catch (e) {
        console.error(e);
      }

      return null;
    },
    navigate(data) {
      Vue.router.push(data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/product/new/index.js